import {
    ADMINGETMAPPINGBANK_SUCCESS,
    ADMINGETMAPPINGBANK_FAILED,
    RESET_ADMINGETMAPPINGBANK,
    LOADING_ADMINGETMAPPINGBANK,
    NETWORK_ERROR_ADMINGETMAPPINGBANK
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMINGETMAPPINGBANK:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADMINGETMAPPINGBANK_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADMINGETMAPPINGBANK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADMINGETMAPPINGBANK:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADMINGETMAPPINGBANK:
            return (state = initialState);
        default:
            return state;
    }
};